import { Button, Card, Modal, message } from 'antd';
import { useEffect, useState } from 'react';
import { authRequest } from '../../../../../../common/request/authRequest';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { DeleteOutlined, InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ButtonLZ } from '../../../../../components/design/Buttons/ButtonLZ';
import { useTranslation } from 'react-i18next';
import { authFetch } from '../../../../../../common/request/authFetch';
import { NewCategoryModal } from './NewCategoryModal';

export const ReviewsCategories = (props: { onTestClick?: () => void }) => {

	const [openModal, setOpenModal] = useState(false);
	const [updateData, setUpdateData] = useState(false);
	const [labels, setLabels] = useState<any>(null);
	const { projectGroup } = useAuth();
	const { t } = useTranslation();

	useEffect(() => {
		authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/category`, {})
			.then((response) => {
				setLabels(response);
			}).catch(() => { message.error('Error al cargar etiquetas') });
	}, [updateData]);

	const deleteLabel = async (labelId: string): Promise<void> => {
		await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/category/${labelId}`, { method: 'DELETE' })
			.then((res) => {
				if (res) {
					message.success('Categoría borrada de forma satisfactoria', 3);
					setUpdateData(!updateData);
				} else {
					message.error('Problema al borrar la categoría', 3);
				}
			})
	}

	return (
		<div>
			<Card
				className='card-layout'
				bodyStyle={{ padding: '14px 16px' }}
				style={{
					background: '#fff',
					margin: 0,
					marginLeft: 0,
					width: '100%',
					borderRadius: 10,
					border: '1px solid rgba(148, 163, 184, 0.28)',
				}}
			>
				<div style={{
					display: 'flex',
					alignItems: 'flex-start',
					justifyContent: 'space-between',
					gap: 12,
					padding: '10px 12px',
					marginBottom: 14,
					borderRadius: 8,
					background: '#f8fafc',
					border: '1px solid rgba(148, 163, 184, 0.22)',
				}}>
					<div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, minWidth: 0 }}>
						<InfoCircleOutlined style={{ color: 'teal', marginTop: 2, flexShrink: 0 }} />
						<small style={{ color: '#64748b', lineHeight: 1.45 }}>
							Define qué categorías quieres analizar y qué criterios debe usar la IA para etiquetar las reseñas; esto es la base para un posterior análisis de sentimiento
						</small>
					</div>
					{props.onTestClick && (
						<ButtonLZ
							size='small'
							type='ghost'
							onClick={props.onTestClick}
							style={{
								fontSize: 12,
								border: '1px solid #e9d5ff',
								background: '#faf5ff',
								color: '#7e22ce',
								height: 30,
								padding: '0 10px',
								flexShrink: 0,
							}}
						>
							<span style={{ display: 'flex', alignItems: 'center', gap: 5, fontWeight: 600 }}>
								<span className="material-symbols-outlined" style={{ fontSize: 15, color: '#7e22ce' }}>auto_awesome</span>
								Pruébame
							</span>
						</ButtonLZ>
					)}
				</div>

				{labels?.length > 0 && (
					<div style={{
						display: 'grid',
						gridTemplateColumns: 'minmax(90px, 1fr) 2fr auto',
						gap: 10,
						padding: '0 12px 6px',
					}}>
						<span style={{
							fontSize: 11,
							fontWeight: 600,
							color: '#94a3b8',
							letterSpacing: '0.03em',
							textTransform: 'uppercase',
						}}>
							Categoría
						</span>
						<span style={{
							fontSize: 11,
							fontWeight: 600,
							color: '#94a3b8',
							letterSpacing: '0.03em',
							textTransform: 'uppercase',
						}}>
							Criterio de etiquetado
						</span>
						<span />
					</div>
				)}

				<div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
					{labels?.map((row: any) => (
						<div
							key={row.id || row.name}
							style={{
								display: 'grid',
								gridTemplateColumns: 'minmax(90px, 1fr) 2fr auto',
								alignItems: 'center',
								gap: 10,
								padding: '10px 12px',
								borderRadius: 8,
								border: '1px solid rgba(148, 163, 184, 0.22)',
								background: '#fff',
							}}
						>
							<div style={{
								borderRadius: 6,
								border: '1px solid #e2e8f0',
								background: '#edf2f7',
								color: '#475569',
								padding: '3px 8px',
								justifySelf: 'start',
								maxWidth: '100%',
							}}>
								<small style={{ fontWeight: 700 }}>{row.name}</small>
							</div>

							<div style={{ textAlign: 'left', minWidth: 0 }}>
								<small style={{ color: '#334155', lineHeight: 1.4 }}>
									{row.labelCriteria
										? <span style={{ fontWeight: 600 }}>{row.labelCriteria}</span>
										: <i style={{ color: '#94a3b8' }}>Sin criterio de etiquetado</i>
									}
								</small>
							</div>

							<Button
								shape='round'
								size='small'
								type='link'
								style={{ color: '#94a3b8', justifySelf: 'end', paddingInline: 4 }}
								onClick={() => {
									Modal.confirm({
										title: 'Confirmas que quieres eliminar esta categoría',
										okText: t('dictionary.confirm'),
										cancelText: t('dictionary.cancel'),
										onOk: () => deleteLabel(row.id)
									})
								}}
							>
								<DeleteOutlined style={{ fontSize: 12 }} />
								<small> Eliminar</small>
							</Button>
						</div>
					))}
				</div>

				<div style={{
					display: 'flex',
					justifyContent: 'flex-end',
					gap: 10,
					alignItems: 'center',
					marginTop: 16,
				}}>
					<ButtonLZ onClick={() => { setOpenModal(true) }}>
						<PlusOutlined /> Añadir categoría
					</ButtonLZ>
				</div>
			</Card>
			{openModal && <NewCategoryModal onFinish={() => { setOpenModal(false); setUpdateData(!updateData) }} onClose={() => { setOpenModal(false) }} />}
		</div>
	)
}
